import { SHOPIFY_CLIENT_ERROR_MESSAGES } from "@shared/constants";
import i18n from "@client-shared/lib/i18n";
import * as api from "@client-shared/services/api";

export const INSTALL_SHOPIFY_ERROR_MESSAGES = {
  INVALID_ACCESS_TOKEN_OR_SCOPE: "Invalid accessToken or scope",
  INVALID_PARAM: "Invalid shop param",
  WEBHOOK_REGISTRATION_FAILED: "Shopify webhook registration failed",
  SESSION_EXISTS_FOR_DOMAIN: "Session for the given domain already exists.",
  MISSING_ACCESS_SCOPES: "Missing access scopes:",
};

/**
 * Installs a Shopify service and handles error mapping to i18n messages.
 */
export const installShopifyService = async (
  shop: string,
  accessToken: string,
  locale: string | undefined
) => {
  let serviceError = new Error(i18n.t("components.ModalServiceForm.installShopifyService.general"));
  try {
    return await api.installShopifyService(shop, accessToken, locale);
  } catch (e) {
    const message = e instanceof Error ? e.message : "";

    if (message === SHOPIFY_CLIENT_ERROR_MESSAGES.INVALID_SHOP) {
      serviceError = new Error(i18n.t("components.ModalServiceForm.installShopifyService.invalidShop"));
      throw serviceError;
    }
    if (message === INSTALL_SHOPIFY_ERROR_MESSAGES.INVALID_ACCESS_TOKEN_OR_SCOPE) {
      serviceError = new Error(i18n.t("components.ModalServiceForm.installShopifyService.invalidAccessTokenOrScope"));
      throw serviceError;
    }
    if (message === INSTALL_SHOPIFY_ERROR_MESSAGES.INVALID_PARAM) {
      serviceError = new Error(i18n.t("components.ModalServiceForm.installShopifyService.invalidShopParam"));
      throw serviceError;
    }
    if (message === INSTALL_SHOPIFY_ERROR_MESSAGES.WEBHOOK_REGISTRATION_FAILED) {
      serviceError = new Error(i18n.t("components.ModalServiceForm.installShopifyService.webhookRegistrationFailed"));
      throw serviceError;
    }
    if (message === INSTALL_SHOPIFY_ERROR_MESSAGES.SESSION_EXISTS_FOR_DOMAIN) {
      serviceError = new Error(i18n.t("components.ModalServiceForm.installShopifyService.sessionExistsForDomain"));
      throw serviceError;
    }
    if (message.toString().includes(INSTALL_SHOPIFY_ERROR_MESSAGES.MISSING_ACCESS_SCOPES)) {
      const data = message.toString();
      const missingScopes = data.substring(data.lastIndexOf(":") + 1).trim();
      serviceError = new Error(
        i18n.t("components.ModalServiceForm.installShopifyService.missingAccessScopes", { missingScopes: missingScopes })
      );
      throw serviceError;
    }
    throw serviceError;
  }
};

/**
 * Installs a WooCommerce service and returns the JWT token.
 */
export const installWooCommerceService = async (shop: string, locale?: string) => {
  try {
    return await api.installWooCommerceService(shop, locale);
  } catch (e) {
    const message = e instanceof Error ? e.message : "";
    throw new Error(message);
  }
};
